import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import {
	SetAppScopeOccupancyTypes,
	SetAcuityOccupancyTypes, SetCmpAcuityOccupancyTypes
} from '../state/actions/global-configuration.actions';

@Injectable()
export class OccupancyTypesLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			await this.store.dispatch(new SetAppScopeOccupancyTypes()).toPromise();
			await this.store.dispatch(new SetAcuityOccupancyTypes()).toPromise();
			await this.store.dispatch(new SetCmpAcuityOccupancyTypes()).toPromise();
			return resolve(true);
		});
	}
}
